import React from "react";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { BottomNav } from "@/components/layout/BottomNav";
import { AnnouncementBanner } from "@/components/layout/AnnouncementBanner";

export function Layout({ children }) {
  return (
    <div className="flex min-h-screen flex-col">
      <a href="#main-content" className="skip-link" data-testid="skip-to-content">Skip to main content</a>
      <AnnouncementBanner />
      <Header />
      <main id="main-content" tabIndex={-1} className="flex-1 pb-20 md:pb-0">{children}</main>
      <Footer />
      <BottomNav />
    </div>
  );
}
